export default __webpack_public_path__ + "static/media/LGO_GBCI_n.d6028c96.png";